var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3281 10.0781C18.3281 11.4997 17.1716 12.6562 15.75 12.6562H8.25C6.82842 12.6562 5.67188 11.4997 5.67188 10.0781V2.57812C5.67188 1.15655 6.82842 0 8.25 0H15.75C17.1716 0 18.3281 1.15655 18.3281 2.57812V10.0781ZM12.8981 4.76393L12 2L11.1019 4.76393H8.19577L10.5469 6.47214L9.64886 9.23607L12 7.52786L14.3511 9.23607L13.4531 6.47214L15.8042 4.76393H12.8981Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.0781C13.3591 19.0781 14.4609 17.9763 14.4609 16.6172C14.4609 15.258 13.3591 14.1562 12 14.1562C10.6409 14.1562 9.53906 15.258 9.53906 16.6172C9.53906 17.9763 10.6409 19.0781 12 19.0781Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8516 19.0781C21.2107 19.0781 22.3125 17.9763 22.3125 16.6172C22.3125 15.258 21.2107 14.1562 19.8516 14.1562C18.4924 14.1562 17.3906 15.258 17.3906 16.6172C17.3906 17.9763 18.4924 19.0781 19.8516 19.0781Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14844 19.0781C5.50758 19.0781 6.60938 17.9763 6.60938 16.6172C6.60938 15.258 5.50758 14.1562 4.14844 14.1562C2.7893 14.1562 1.6875 15.258 1.6875 16.6172C1.6875 17.9763 2.7893 19.0781 4.14844 19.0781Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5473 19.3867C21.8501 20.0658 20.8989 20.4853 19.8511 20.4853C18.8033 20.4853 17.8521 20.0658 17.155 19.3867C17.024 19.501 16.9006 19.6236 16.7852 19.7534C17.2445 20.5573 17.5074 21.4872 17.5074 22.4775V24.0009H23.2495C23.6379 24.0009 23.9527 23.6861 23.9527 23.2978V22.4775C23.9527 21.2444 23.4085 20.1386 22.5473 19.3867Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84459 19.3867C6.14742 20.0658 5.19623 20.4853 4.14844 20.4853C3.10064 20.4853 2.14945 20.0658 1.45228 19.3867C0.591094 20.1386 0.046875 21.2444 0.046875 22.4775V23.2978C0.046875 23.6861 0.361687 24.0009 0.75 24.0009H6.49219V22.4775C6.49219 21.4872 6.75502 20.5572 7.21439 19.7534C7.09894 19.6236 6.97547 19.501 6.84459 19.3867Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6962 19.3867C13.999 20.0658 13.0478 20.4853 12 20.4853C10.9522 20.4853 10.001 20.0658 9.30384 19.3867C8.44266 20.1386 7.89844 21.2444 7.89844 22.4775V24.0009H16.1016V22.4775C16.1016 21.2444 15.5573 20.1386 14.6962 19.3867Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon14.717d3a21e44bde2610d5b61fe7e3b6a2.svg";
export { ForwardRef as ReactComponent };